var cruiseCompanies = {
  W: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1716882596/web/cruise-logos/ama-waterways.svg',
    name: 'Ama Waterways'
  },
  Z: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740736988/web/cruise-logos/azamara-club-cruises.svg',
    name: 'Azamara Club Cruises'
  },
  C: {
    url: 'https://img.ving.se/image/upload/v1740736825/web/cruise-logos/celebrity-cruises-color.png',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717510792/web/cruise-logos/celebrity-cruises.svg',
    name: 'Celebrity Cruises'
  },
  U: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717510796/web/cruise-logos/cunard.svg',
    name: 'Cunard'
  },
  J: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717510794/web/cruise-logos/explora.svg',
    name: 'Explora Journeys'
  },
  F: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717572685/web/cruise-logos/fred-olsen-cruise-line.svg',
    name: 'Fred Olsen Cruise Line'
  },
  L: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717510794/web/cruise-logos/hapag-lloyd.svg',
    name: 'Hapag-Lloyd Cruises'
  },
  H: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717510792/web/cruise-logos/holland-america-line.svg',
    name: 'Holland America Line'
  },
  HAVILA: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1718605328/web/cruise-logos/havila.svg',
    name: 'Havila Voyages'
  },
  X: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717510796/web/cruise-logos/hurtigruten-expeditions.svg',
    name: 'HX Hurtigruten Expeditions'
  },
  G: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1718694948/web/cruise-logos/hurtigruten.svg',
    name: 'Hurtigruten'
  },
  K: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717510795/web/cruise-logos/kystruten.svg',
    name: 'Havila Kystruten'
  },
  V: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1717510794/web/cruise-logos/oceania.svg',
    name: 'Oceania Cruises'
  },
  P: {
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647719/web/cruise-logos/princess-cruises.svg',
    name: 'Princess Cruises'
  },
  E: {
    name: 'Regent Seven Seas Cruises',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/regent.svg'
  },
  Q: {
    name: 'Scenic Ocean Cruises',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/scenic.svg'
  },
  S: {
    name: 'Sea Cloud Cruises',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/sea-cloud.svg'
  },
  B: {
    name: 'Seabourn',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/seabourn.svg'
  },
  D: {
    name: 'SeaDream Yacht Club',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/seadream.svg'
  },
  I: {
    name: 'Silversea',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/silversea.svg'
  },
  'SILVERSEA-EXP': {
    name: 'Silversea Expeditions',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/silversea-expeditions.svg'
  },
  T: {
    name: 'Star Clippers',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/star-clippers.svg'
  },
  'RITZ-CARLTON': {
    name: 'Ritz-Carlton Yacht Collection',
    globetrotterUrl: 'https://img.globetrotter.se/image/upload/v1740647843/web/cruise-logos/the-ritz-carlton.svg'
  },
  O: {
    name: 'Costa Cruises',
    url: 'https://img.nltg.com/image/upload/v1740730936/web/cruise-logos/costa-cruises.svg'
  },
  R: {
    name: 'Royal Caribbean International',
    url: 'https://img.nltg.com/image/upload/v1740730936/web/cruise-logos/royal-caribbean-international.svg'
  },
  N: {
    name: 'Norwegian Cruise Line',
    url: 'https://img.nltg.com/image/upload/v1740730936/web/cruise-logos/norwegian-cruise-line.svg'
  }
};

export { cruiseCompanies };
//# sourceMappingURL=cruiseCompanies.js.map
